import { createReducer, on } from '@ngrx/store'
import * as CalendarEventsActions from './calendar-events.actions'
import { initialCalendarEventsState } from './calendar-events.state'

export const calendarEventsReducer = createReducer(
   initialCalendarEventsState,

   on(CalendarEventsActions.loadMailingList, (state) => {
      return { ...state, mailingLists: undefined, isLoadingMailingLists: true }
   }),
   on(CalendarEventsActions.loadMailingListSuccess, (state, action) => {
      return { ...state, mailingLists: action.response, isLoadingMailingLists: undefined }
   }),
   on(CalendarEventsActions.loadMailingListFailed, (state) => {
      return { ...state, mailingLists: undefined, isLoadingMailingLists: undefined }
   }),
   on(CalendarEventsActions.clearMailingList, (state) => {
      return { ...state, mailingLists: undefined, isLoadingMailingLists: undefined }
   }),

   on(CalendarEventsActions.loadSingleMailingList, (state) => {
      return { ...state, activeMailingList: undefined, isLoadingActiveMailingList: true }
   }),
   on(CalendarEventsActions.loadSingleMailingListSuccess, (state, action) => {
      return { ...state, activeMailingList: action.response, isLoadingActiveMailingList: undefined }
   }),
   on(CalendarEventsActions.loadSingleMailingListFailed, (state) => {
      return { ...state, activeMailingList: undefined, isLoadingActiveMailingList: undefined }
   }),

   on(CalendarEventsActions.loadEventList, (state, action) => {
      return action.modePreview ? { ...state, previewEvents: undefined, isLoadingPreviewEvents: true } : { ...state, events: undefined, isLoadingEvents: true }
   }),
   on(CalendarEventsActions.loadEventListSuccess, (state, action) => {
      return action.modePreview
         ? { ...state, previewEvents: action.response, isLoadingPreviewEvents: undefined }
         : { ...state, events: action.response, isLoadingEvents: undefined }
   }),
   on(CalendarEventsActions.loadEventListFailed, (state, action) => {
      return action.modePreview
         ? { ...state, previewEvents: undefined, isLoadingPreviewEvents: undefined }
         : { ...state, events: undefined, isLoadingEvents: undefined }
   }),
   on(CalendarEventsActions.clearEventList, (state) => {
      return { ...state, events: undefined, isLoadingEvents: undefined, previewEvents: undefined, isLoadingPreviewEvents: undefined }
   }),

   on(CalendarEventsActions.loadSingleEvent, (state) => {
      return { ...state, activeEvent: undefined, isLoadingActiveEvent: true }
   }),
   on(CalendarEventsActions.loadSingleEventSuccess, (state, action) => {
      return { ...state, activeEvent: action.response, isLoadingActiveEvent: undefined }
   }),
   on(CalendarEventsActions.loadSingleEventFailed, (state) => {
      return { ...state, activeEvent: undefined, isLoadingActiveEvent: undefined }
   }),

   on(CalendarEventsActions.loadDoodleList, (state, action) => {
      return { ...state, doodles: undefined, doodlesTotal: undefined, doodlesParams: action.params, isLoadingDoodles: true }
   }),
   on(CalendarEventsActions.loadDoodleListSuccess, (state, action) => {
      return { ...state, doodles: action.response.doodles, doodlesTotal: action.response.totalRecords, isLoadingDoodles: undefined }
   }),
   on(CalendarEventsActions.loadDoodleListFailed, (state) => {
      return { ...state, doodles: undefined, doodlesTotal: undefined, isLoadingDoodles: undefined }
   }),

   on(CalendarEventsActions.clearDoodleList, (state) => {
      return { ...state, doodles: undefined, doodlesTotal: undefined, doodlesParams: undefined, isLoadingDoodles: undefined }
   }),
   on(CalendarEventsActions.setDoodleListFilters, (state, action) => {
      return { ...state, doodleFilters: action.filters }
   }),

   on(CalendarEventsActions.loadDoodle, (state) => {
      return { ...state, activeDoodle: undefined, isLoadingActiveDoodle: true }
   }),
   on(CalendarEventsActions.loadDoodleSuccess, (state, action) => {
      return { ...state, activeDoodle: action.response, isLoadingActiveDoodle: undefined }
   }),
   on(CalendarEventsActions.loadDoodleFailed, (state) => {
      return { ...state, activeDoodle: undefined, isLoadingActiveDoodle: undefined }
   })
)
